import { getDownloadURL, ref } from 'firebase/storage';
import { existingStorage, storage } from './firebase';

interface NftMediaParams {
  fileName: string;
  raceAlias?: string;
  projectId?: string;
}

/** NFT動画/画像のURLを取得 */
export async function getNftMediaUrl(params: NftMediaParams): Promise<string> {
  const { fileName, raceAlias, projectId } = params;

  // dot99のclaimはprojectIdを持つ
  if (projectId) {
    const path = `nft/${projectId}/${fileName}`;
    const storageRef = ref(existingStorage, path);
    return getDownloadURL(storageRef);
  }

  // heraldingera のclaim
  if (raceAlias) {
    const path = `nft/${raceAlias}/${fileName}`;
    const storageRef = ref(storage, path);
    return getDownloadURL(storageRef);
  }

  throw new Error('raceAlias or projectId is required');
}

/** クーポン画像のURLを取得 */
export async function getImageUrl(imageSource: string): Promise<string> {
  const storageRef = ref(storage, imageSource);
  return getDownloadURL(storageRef);
}
